import {Injectable} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {CustomError} from '../models/shared/custom-error';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  constructor(
    private toastr: ToastrService
  ) {
  }

  publishError(err: CustomError) {
    if (err.message !== 'Invalid Token!') {
      this.toastr.error(err.message, err.title);
    }
  }

  publishErrorMessage(mess, title: string) {
    this.toastr.error(mess, title);
  }

  publishSuccessMessage(mess, title: string) {
    this.toastr.success(mess, title);
  }

  publishInfoMessage(mess, title: string) {
    this.toastr.info(mess, title);
  }

  publishWarningMessage(mess, title: string) {
    this.toastr.warning(mess, title);
  }
}
